<template>
<div class="container-fluid">
    <div class="row">
        <div>
            <h4 class="admin_txt">State Enrolled</h4>
        </div>
        <div v-if='!showAdvananced' class="card_box">
            <vue-bootstrap4-table v-if="rows.length" :rows="rows" :columns="columns" :config="config">
                <template slot="empty-results">
                    No State Enrolled Found
                </template>
                <template slot="id" slot-scope="props">
                    <span>
                        {{props.row.vbt_id}}
                    </span>
                </template>
                <template slot="stateName" slot-scope="props">
                    <span style="text-transform: capitalize">
                        {{props.cell_value.toLowerCase()}}
                    </span>
                </template>
                <template slot="stateCode" slot-scope="props">
                    <span>
                        {{props.cell_value}}
                    </span>
                </template>
                <template slot="action" slot-scope="props">
                    <span>
                        <button @click="gotoSet(props.row)" class="btn_set">Settings</button>
                    </span>
                    <span style="margin-left:2px">
                        <button @click="act_deact(props.row)" class="btn_dact" v-if="props.row.suspendedStatus ==0">Deactivate</button>
                        <button @click="act_deact(props.row)" class="btn_act" v-if="props.row.suspendedStatus ==1">Activate</button>
                    </span>
                </template>
                <template slot="sort-asc-icon">
                    <i class="fas fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                    <i class="fas fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                    <i class="fas fa-sort"></i>
                </template>
            </vue-bootstrap4-table>
        </div>
    </div>

    <!--  -->

    <div class="row col-xl-12" v-if='showAdvananced'>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Services</h4>
                <b-form-checkbox v-for=" (rights,index) in allServices" :key="rights.serviceId" v-model="rights.right" @change="serviceSelected(rights.serviceId,rights.right,index)" v-bind:id="rights.serviceId" class="bb"><span class="label_url">{{rights.serviceName}}</span></b-form-checkbox>
            </div>
        </div>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Documents</h4>
                <b-form-checkbox v-for=" (rights2,index) in allDocuments" :key="rights2.documentId" v-model="rights2.right" @change="documentSelected(rights2.documentId,rights2.right,index)" v-bind:id="rights2.documentId" class="bb"><span class="label_url">{{rights2.documentName}}</span></b-form-checkbox>
            </div>
        </div>
        <div class="col-md-4">
            <div class="cardmax">
                <h4 class="header-title mt-0 mb-3" style="">Add Items</h4>
                <b-form-checkbox v-for=" (rights1,index) in allItems" :key="rights1.serviceId" v-model="rights1.right" @change="itemsSelected(rights1.itemId,rights1.right,index)" v-bind:id="rights1.itemId" class="bb"> <span class="label_url"> {{rights1.itemName}} </span>
                    <div v-bind:id="'bi'+index" class="mini">
                        <br>
                        <div style="padding: 10px">
                            <label for="userName">Settlement Type : </label>
                            <!-- Settlement Type : {{rights.enabler}} - {{rights.serviceId}}<switches v-model="rights.enabler" theme="bootstrap" color="danger" v-bind:id="'ax'+rights.serviceId"></switches> -->
                            <span style="margin-right: 5px"> &#8358;</span>
                            <toggle-button v-model="enabler" @change="sttleType(rights1.itemId,enabler)" /><span style="margin-left: 5px">%</span>
                        </div>
                        <div style="padding-left: 10px">
                            <div style="margin-bottom: 10px">
                                <label for="userName">Settlement Value : </label>
                                <input type="number" n parsley-trigger="change" required placeholder="Enter value" v-model="score[index]" @change="setValue(index)" class="setvalue">
                            </div>
                        </div>
                    </div>
                </b-form-checkbox>
            </div>
        </div>
        <!-- <div class="form-group text-right mb-0 col-md-12">
            <button class="btn btn-primary waves-effect waves-light mr-1" type="submit">
                Save
            </button>
            <button type="reset" class="btn btn-secondary waves-effect waves-light">
                Cancel
            </button>
            </form>
        </div> -->
        <div style="padding: 20px 0" class="row">
            <div class="col-lg-12">
                <div class="url_txt">
                    <div class="validation">
                        <div class="pt-4 px-10 validate_txt">
                            <h6>Validation Identifcation</h6>
                        </div>
                        <div style="padding-top: 20px" class="">
                            <!-- <label style=""></label> -->
                            <b-form-checkbox @change="showUrl == !showUrl" v-model="showUrl" class="b2"><span class="label_url" style="">Validate ID</span></b-form-checkbox>
                            <!-- <v-checkbox style="padding-top: 14px; padding-left: 15px" v-model="ValidateID" label="Validate ID" @change="!showUrl" value="ValidateID"></v-checkbox> -->
                        </div>
                        <div v-if="showUrl" class="px-10 pt-2 validate_txt">
                            <h6>Provide Url</h6>
                            <input type="text" placeholder="url">
                        </div>
                    </div>
                </div>
                <div style="margin: 20px 0" class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-4">
                        <div class="btn_class">
                            <form @submit.prevent>
                                <button class="cancel" @click="cancelSet()">Cancel</button>
                                <button class="save" @click.prevent="enrollState()">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'

///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";
/////////////////////////
import router from '@/router/index'
///////// IMPORT COOKIE SERVICE

import VueBootstrap4Table from 'vue-bootstrap4-table'

import httpRequest from "@/services/httpRequests.js";
export default {
    name: 'enroled',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            showAdvananced: false,
            showUrl: false,
            state: null,
            allServices: '',
            rights: Array,
            allItems: '',
            allDocuments: '',
            enabler: '',
            score: [],
            paramUpdate: {
                stateCode: '',
                stateAddress: '',
                services: [],
                documents: [],
                items: [],
            },
            item: {
                //...
                image: null,
                imageUrl: null
            },
            columns: [{
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "State Name",
                    name: "stateName",
                    //   slot_name: "stateName",
                    sort: true,
                },
                {
                    label: "State Code",
                    name: "stateCode",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                }
            ],
            rows: [],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                selected_rows_info: true,
                card_title: "States Enrolled",
                global_search: {
                    placeholder: "Search Uploads",
                    visibility: true,
                    case_sensitive: false,
                },
                pagination: true, // default true
                pagination_info: false, // default true
                num_of_visibile_pagination_buttons: 7, // default 5
                per_page: 5, // default 10
                per_page_options: [5, 10, 20, 30],
            },
            // config: {
            //     show_refresh_button: false,
            //     show_reset_button: false,
            //     checkbox_rows: false,
            //     rows_selectable: true,
            //     selected_rows_info: true,
            //     card_title: "States Enrolled",
            //     global_search: {
            //         placeholder: "Search Uploads",
            //         visibility: true,
            //         case_sensitive: false,
            //     },
            // },
        };
    },

    mounted() {
        //       var thiss = this
        //   const fetch = httpRequest.get('state/getstates').then(function(res){
        //     let statestoEnroll = httpRequest.detokenizeData(res.data.dataToken)
        //  statestoEnroll = statestoEnroll.data.filter((item) => {
        //           return (item.enrolledStatus == 0)
        //         })
        //       thiss.statestoEnroll = statestoEnroll
        // })
        var thiss = this
        const fetchservices = httpRequest.get('services/all').then(function (res) {
            const services = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler = [];
            services.data.map(function (key, value) {
                key['enabler'] = 'a' + key['serviceId']
                switchEnabler['a' + key['serviceId']] = false
            });
            thiss.enabled = switchEnabler;
            thiss.allServices = services.data
        })
        ///////// get all items
        const fetchitems = httpRequest.get('item/all').then(function (res) {
            const items = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler1 = [];
            items.data.map(function (key, value) {
                key['enabler'] = 'a' + key['serviceId']
                switchEnabler1['a' + key['serviceId']] = false
            });
            thiss.enabled = switchEnabler1;
            thiss.allItems = items.data
        })

        ///////// get all Documents
        const fetchdocs = httpRequest.get('document/get/all').then(function (res) {
            // const items = httpRequest.detokenizeData(res.data.dataToken);
            const switchEnabler2 = [];
            res.data.documents.map(function (key, value) {
                key['enabler'] = 'a' + key['documentId']
                switchEnabler2['a' + key['documentId']] = false
            });
            thiss.enabled = switchEnabler2;
            thiss.allDocuments = res.data.documents
        })
    },

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('state/enrolled').then(function (res) {
            next(vm => vm.setData(res))
        })
    },

    /// SCOPE METHODS
    methods: {
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },
        enrollState() {
            let thiss = this
            const data = {
                stateName: this.state.stateName,
                stateCode: this.state.stateCode,
            }
            // console.log(this.paramUpdate);
            const fetch = httpRequest.post('state/enroll', data).then(function (res) {
                console.log(res);
                if (res.data.code == 's200') {
                    thiss.alertDisplay('Settings Saved', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Settings Not Saved', res.data.message, 'error');
                }
            })

        },
        cancelSet() {
            let reset = {
                stateCode: '',
                stateAddress: '',
                services: [],
                items: [],
            }
            console.log(BFormCheckbox);
            this.paramUpdate = reset
            this.showAdvananced = false
        },

        serviceSelected(service, status, index) {
            console.log(status);
            //// if checkbox is selected
            if (status == true) {
                //$('#bb'+index).css("display", "inline");
                let servicesSelected = {
                    "serviceId": service,
                    "key": index
                }
                /// add to the services selected in paramUpdate
                this.paramUpdate.services.push(servicesSelected)
            } else {
                //// if checkbox is deselected remove from paramUpdate
                // $('#bb'+index).css("display", "none");
                const indexd = this.paramUpdate.services.map(function (element) {
                        return element.serviceId;
                    })
                    .indexOf(service);
                console.log(indexd);
                if (indexd > -1) {
                    this.paramUpdate.services.splice(indexd, 1);
                }
            }
            console.log(service)
            console.log(status)
        },

        documentSelected(document, status, index) {
            console.log(status);
            //// if checkbox is selected
            if (status == true) {
                //$('#bb'+index).css("display", "inline");
                let documentSelected = {
                    "documentId": document,
                    "key": index
                }
                /// add to the services selected in paramUpdate
                this.paramUpdate.documents.push(documentSelected)
            } else {
                //// if checkbox is deselected remove from paramUpdate
                // $('#bb'+index).css("display", "none");
                const indexd = this.paramUpdate.documents.map(function (element) {
                        return element.documentId;
                    })
                    .indexOf(document);
                console.log(indexd);
                if (indexd > -1) {
                    this.paramUpdate.documents.splice(indexd, 1);
                }
            }
            console.log(service)
            console.log(status)
        },
        itemsSelected(item, status, index) {
            console.log(status);
            if (status == true) {
                $('#bi' + index).css("display", "inline");
                let itemsSelected = {
                    "itemId": item,
                    "settlementType": "percent",
                    "settlementValue": "",
                    "key": index
                }
                this.paramUpdate.items.push(itemsSelected)
            } else {
                $('#bi' + index).css("display", "none");
                const indexd = this.paramUpdate.items.map(function (element) {
                        return element.itemId;
                    })
                    .indexOf(item);
                console.log(indexd);
                if (indexd > -1) {
                    //////// remove from score watch and splice from paramUpdate
                    this.score[index] = null
                    this.paramUpdate.items.splice(indexd, 1);
                }
            }
            console.log(item)
            console.log(status)
        },
        setData(data) {
            let statestoEnrolled = httpRequest.detokenizeData(data.data.dataToken)
            this.rows = statestoEnrolled.data
            console.log(this.statestoEnrolled)
        },
        gotoSet(state) {
            this.state = state;
            console.log(state);
           const stateCode = this.state.stateCode
            console.log(stateCode)
            const fetch = httpRequest.get(`settings/get/${stateCode}`).then(function (res) {
                console.log('Jeg');
                console.log(res);
                // if (res.data.code == 's200') {
                //     thiss.alertDisplay('Settings Saved', res.data.message, 'success');
                // } else {
                //     thiss.alertDisplay('Settings Not Saved', res.data.message, 'error');
                // }
            })
            this.showAdvananced = true;
        },
        act_deact: function (x) {
            let thiss = this
            let switchy = x.suspendedStatus == '0' ? '1' : '0'
            let swdisplay = x.suspendedStatus == '1' ? 'Activated state' : 'Deactivated State'
            const fetch = httpRequest.put('state/suspend/' + x.stateCode).then(function (res) {
                console.log(res)
                console.log(`this is x log ${x}`);
                if (res.data.code == '200') {
                    // console.log(stateCode)
                    thiss.rows.forEach(function (key, value) {
                        let vbcount = parseInt(value) + 1;
                        console.log(vbcount);
                        if (x.vbt_id == vbcount) {
                            thiss.rows[value].suspendedStatus = switchy
                        }
                    })
                    thiss.$swal(swdisplay, res.data.message, 'success');
                } else if (res.data.status == 'error') {
                    console.log('Error')
                    thiss.$swal(swdisplay, res.data.message, 'error');
                }
            })
        }

    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

template {
    position: relative;
    min-height: 100%;
}

.card-header {
    font-weight: 600 !important;
    background-color: red;
}

.mini {
    display: none;
}

.mini2 {
    width: 287px;
    height: 239px;

    background: #F9F9F9;
    border-radius: 4px;
}

.label_url {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #494949;
    padding-left: 10px
}

input {
    width: 25%;
    height: 52px;
    background: #EEEEEE;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    border-radius: 4px;
    padding-left: 20px;
}

.validation {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 0 25px;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.url_txt {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 20px 0;
}

.cardmax {
    margin-top: 20px;
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 30px;
}

.header-title {
    font-weight: 600;
    font-size: 15px;
    background: #FFF1F1;
    padding: 10px;
    color: #555A6E;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 115.5%;
}

.cancel {
    padding: 10px;
    width: 200px;
    height: 60px;
    background: #EEEEEE;
    border-radius: 4px;
    margin-right: 20px;
    border: none;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #9A9A9A;
}

.save {
    padding: 10px;
    width: 200px;
    height: 60px;
    border: none;
    background: #555A6E;
    border-radius: 4px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #FFFFFF;
}

.bb {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 15px 20px;
}

.b2 {
    width: 25%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 15px 20px;
}

.admin_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

.btn_dact {
    padding: 10px;
    width: 89px;
    height: 34px;
    border: none;
    margin: 0 10px;
    background: #FFF1F1;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #AE171D;
}

.btn_act {
    padding: 10px;
    width: 89px;
    height: 34px;
    border: none;
    margin: 0 10px;
    background: #D9FFE1;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1D9C5F;
}

.card_box {
    width: 100%;
    height: auto;
    margin: 40px 0;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 5% 20px;
}

.btn_set {
    padding: 10px;
    width: 64;
    height: 34px;
    border: none;
    background: #E9F0FF;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height */

    text-align: center;

    color: #1A87CA;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}
</style>
